export const fieldList = document.querySelector('#attributeList > ul');


/**
 * Email
 */
export const emailField = document.getElementById('email');
export const emailFieldlabel = document.querySelector('label[for="email"]');
export const emailFieldEditButton = document.getElementById('email_ver_but_edit');
export const emailFieldErrorFormat = document.getElementById('email_incorrect_format');
export const emailFieldWrapper = document.createElement('div');
export const emailFieldReadOnly = document.createElement('span');


/**
 * Password
 */
export const passwordChooseField = document.getElementById('newPassword');
export const passwordConfirmField = document.getElementById('reenterPassword');
export const passwordForgotLink = document.getElementById('forgotPassword');

/**
 * MFA checkbox
 */
export const mfaField = document.getElementById('extension_mfaEnabled_true');


/**
 * Verification code
 */
export const verificationSendButton = document.getElementById('email_ver_but_send');
export const verificationCodeLabel = document.getElementById('email_ver_input_label');
export const verificationCodeField = document.getElementById('email_ver_input');
export const verificationCodeHelp = document.getElementById('verification-code-help');
export const verificationCodeVerifyButton = document.getElementById('email_ver_but_verify');
export const verificationCodeResendButton = document.getElementById('email_ver_but_resend');
export const verificationFieldSuccess = document.getElementById('email_success');
export const verificationFieldErrorRetry = document.getElementById('email_fail_retry');
export const verificationFieldErrorNoRetry = document.getElementById('email_fail_no_retry');
export const verificationFieldErrorThrottled = document.getElementById('email_fail_throttled');
export const verificationFieldErrorCodeExpired = document.getElementById('email_fail_code_expired');
export const verificationFieldErrorServer = document.getElementById('email_fail_server');
export const verificationCodeFieldWrapper = document.createElement('div');


/**
 * Display name
 */
export const displayNameField = document.getElementById('displayName');


/**
 * CTA
 */
export const createAccountButton = document.getElementById('continue');
